import { point } from '../../../elements/point';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createSwitchIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const drawSwitchArrow = (startX: number, endX: number, y: number) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from: point.create(startX, y),
        to: point.create(endX, y),
        headWidth: 10,
        headHeight: 5.2,
        tailWidth: 3.6,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${drawSwitchArrow(18.4, 34.4, 10.4)}
    ${drawSwitchArrow(21.6, 5.6, 16.8)}
    ${drawSwitchArrow(18.4, 34.4, 23.2)}
    ${drawSwitchArrow(21.6, 5.6, 29.6)}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const switchIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createSwitchIcon,
);
